(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Symptom', Symptom);

    Symptom.$inject = ['$resource'];

    function Symptom ($resource) {
        var resourceUrl =  'api/symptoms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
